import { nanoid } from "nanoid";
import JSZip from "jszip";

export function deepCopy(obj: object) {
  return JSON.parse(JSON.stringify(obj));
}

export function createId() {
  return nanoid(8);
}

export async function fetchZIP(path: string, cb: (data: object) => void) {
  await fetch(path)
    .then((response) => {
      if (response.status === 200 || response.status === 0) {
        return Promise.resolve(response.blob());
      } else {
        return Promise.reject(new Error(response.statusText));
      }
    })
    .then((res) => JSZip.loadAsync(res))
    .then((zip) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return zip.file("data.json").async("string");
    })
    .then((text) => {
      const data = JSON.parse(text);
      cb(data);
    });
}
